import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=1ff3be5b&scoped=true&"
import script from "./change-password.vue?vue&type=script&lang=ts&"
export * from "./change-password.vue?vue&type=script&lang=ts&"
import style0 from "./change-password.vue?vue&type=style&index=0&id=1ff3be5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff3be5b",
  null
  
)

export default component.exports